import Vue from 'vue';

export default {
    storeResume(context, file) {
        const url = 'v1/me/resumes';
        const data = new FormData();
        data.append('file', file);
        return Vue.$axios.$post(url, data);
    },

    saveResumeFromUrl(context, data){
        const url = 'v1/me/resumes/save-from-url';
        return Vue.$axios.$post(url, data);
    },

    getResume({ commit }) {
        const url = 'v1/me/resumes';
        return Vue.$axios.$get(url).then((response) => {
            commit('STORE_RESUME', response.data);
            return response;
        });
    },

    updateResume(context, { id, data }) {
        const url = `v1/me/resumes/${id}`;
        return Vue.$axios.$put(url, data);
    },

    destroyResume(context, id) {
        const url = `v1/me/resumes/${id}`;
        return Vue.$axios.$delete(url);
    },

    downloadResume(context, uuid) {
        const url = `v1/download-file/${uuid}`;
        return Vue.$axios.get(url, {
            responseType: 'blob',
            timeout: 30000,
        });
    },

    disabledResumes(context, excludedId) {
        context.state.resumes.forEach((o, idx) => {
            if (o.id !== excludedId) {
                context.commit('UPDATE_RESUME_DEFAULT_FIELD', { index: idx, is_default: false });
            }
        });
    },

    createGuestResume(context, data) {
        const url = 'v1/guest-resume';
        return Vue.$axios.$post(url, data);
    },

    getGuestResume(context, uuid) {
        const url = `v1/get-file/${uuid}`;
        return Vue.$axios.$get(url);
    },
};
